<template lang="pug">
  .return-customer-xsell
    Xsell
      transition-group(name="fade" tag="div")
        XsellProduct(v-for="item in items" :item="item" :key="item.id" @add-product="addProductToRefillCart" :can-attach="canAttachThisItem(item)" :processing="modifyingRefillProduct == item.id").row

</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';
  import Xsell from "../../../Xsell";
  import XsellProduct from "../../../Xsell/XsellProduct";

  export default {
    name: "ReturnCustomerXsell",
    components: {
      XsellProduct,
      Xsell
    },

    inject: ['getObjProperty'],

    data() {
      return {
        ctaSource: 'rcdMembershipXsell'
      }
    },

    computed: {
      ...mapState('refillCart', [
        'refillCart',
        'modifyingRefillProduct'
      ]),

      ...mapState('xsell', ['membershipXsellProducts']),
      ...mapGetters('refillCart', ['productIdInRefillCart']),

      items() {
        return this.membershipXsellProducts.filter(refillItem => !this.productIdInRefillCart(refillItem.id));
      },

      baseSubscription() {
        //- take the first sub, subscriptionsInCart should always have main sub at index 0
        return this.getObjProperty(this, 'refillCart.subscriptionsInCart.0') || {};
      }
    },

    methods: {
      ...mapActions('refillCart', [
        'addToRefillCart',
        'initRefillCart',
        'loadRefillCart'
      ]),
      ...mapActions('subscriptions', ['addSubAttachment']),
      ...mapActions('xsell', ['getMembershipXsellProducts']),

      addProductToRefillCart(e, item, attachToSub) {
        //- when attaching to sub we need to call subscriptions.addSubAttachment
        let product_id = item.id;

        if (attachToSub) {
          let payload = {
            sub_id: this.baseSubscription.subscription_id,
            product_id,
            qty: 1,
            ctaSource: this.ctaSource
          };

          this.addSubAttachment(payload).finally(this.loadRefillCart);
        } else { //- for regular refill cart as simple one-time product
          let payload = {
            product_id,
            qty: 1,
            ctaSource: this.ctaSource
          };

          this.addToRefillCart(payload);
        }
      },

      canAttachThisItem(item) {
        return (this.baseSubscription.subscriptionAttachments || []).some(att => att.code == item.product_type);
      }
    },

    mounted() {
      this.initRefillCart();
      this.getMembershipXsellProducts();
    }
  }
</script>

<style scoped lang="stylus">

</style>